if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.featured-collection__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.blockId = this.dataset.blockId;
        this.block = this.closest(`[data-id="${this.blockId}"]`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.enableSlider = this.dataset.enableSlider === 'true';

        if (!this.enableSlider || !this.sliderWrapper) return;

        this.fixQuickviewDuplicate();

        this.classList.add('fc-native-scroll');
        this.classList.remove('swiper');
        this.sliderWrapper.classList.remove('swiper-wrapper');
        this.sliderWrapper.classList.add('f-grid');

        const scroller = this;
        const prev = this.block && this.block.querySelector(this.selectors.prevEl);
        const next = this.block && this.block.querySelector(this.selectors.nextEl);
        const pag = this.block && this.block.querySelector('.swiper-pagination');
        let fill = null;
        if (pag) {
          pag.classList.add('swiper-pagination-progressbar', 'swiper-pagination-horizontal');
          fill = document.createElement('span');
          fill.className = 'swiper-pagination-progressbar-fill';
          pag.appendChild(fill);
        }
        const step = () => Math.max(scroller.clientWidth * 0.9, 240);

        function updateBar() {
          if (!fill) return;
          const max = scroller.scrollWidth - scroller.clientWidth;
          const progress = max > 0 ? scroller.scrollLeft / max : 0;
          const thumb = 0.5;
          fill.style.transform = 'translateX(' + (progress * (1 - thumb) * 100) + '%) scaleX(' + thumb + ')';
        }

        if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); scroller.scrollBy({ left: -step(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', (e) => { e.preventDefault(); scroller.scrollBy({ left: step(), behavior: 'smooth' }); });
        scroller.addEventListener('scroll', updateBar, { passive: true });
        updateBar();
      }

      fixQuickviewDuplicate() {
        let modalIds = [];
        Array.from(this.querySelectorAll('quick-view-modal')).forEach((modal) => {
          const modalID = modal.getAttribute('id');
          if (modalIds.includes(modalID)) modal.remove();
          else modalIds.push(modalID);
        });
      }
    }
  );
}